// extracted by mini-css-extract-plugin
export default {"containerAbout":"About_containerAbout__Inq5P","sobre":"About_sobre__rB4WK"};